import React from 'react';
import { CModal, CModalBody, CSpinner } from '@coreui/react-pro';

const LoadingModal = ({ visible, message }) => {
  return (
    <CModal
      visible={visible}
      backdrop="static"
      keyboard={false}
      alignment="center"
      size="sm"
    >
      <CModalBody className="text-center p-4">
        <div className="mb-3">
          <CSpinner color="primary" size="lg" />
        </div>
        <div className="text-muted">
          {message || "Lütfen bekleyin, doküman indiriliyor, bu işlem bir kaç dakika sürebilir"}
        </div>
      </CModalBody>
    </CModal>
  );
};

export default LoadingModal;

